module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/influencer-joey-swoll-575717d97f411dc68a79aff42bed1f68.jpg";